import { render } from "./DoGoodPage.vue?vue&type=template&id=6a3d0f52&scoped=true"
import script from "./DoGoodPage.vue?vue&type=script&lang=js"
export * from "./DoGoodPage.vue?vue&type=script&lang=js"

import "./DoGoodPage.vue?vue&type=style&index=0&id=6a3d0f52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3d0f52"]])

export default __exports__